import React from "react";
import T from "prop-types";

import Buttons, { ButtonsSet } from "2g-buttons";
import Form, { Field, FieldStatic, Inputs, Row, ActionButton } from "2g-form";
import { required } from "2g-validators-common";

import { ImageChooser, FileChooser } from "b2b/components/prilohy";

import useMessages from "./i18n/useMessages";

const requiredValidator = required();

function ProvozniInformaceForm({ onCancel, onDelete, ...props }) {
  const messages = useMessages();
  return (
    <Form {...props} className="b2b-ProvozniInformaceForm">
      <div className="b2b-ProvozniInformaceForm-imageTitles">
        <FieldStatic label={messages.image()}>
          <ImageChooser path="obrazek" />
        </FieldStatic>
        <div className="b2b-ProvozniInformaceForm-titles">
          <Row styled>
            <Field
              component={Inputs.Input}
              path="nazevCs"
              label={messages.titleCs()}
              placeholder={messages.titleCsPlaceholder()}
              maxLength={100}
              required
              validators={requiredValidator}
            />
          </Row>
          <Row styled>
            <Field
              component={Inputs.Input}
              path="nazevEn"
              label={messages.titleEn()}
              placeholder={messages.titleEnPlaceholder()}
              maxLength={100}
              required
              validators={requiredValidator}
            />
          </Row>
          <Row styled>
            <Field
              component={Inputs.Input}
              path="popisCs"
              label={messages.descriptionCs()}
              placeholder={messages.descriptionCsPlaceholder()}
              maxLength={200}
              required
              validators={requiredValidator}
            />
          </Row>
          <Row styled>
            <Field
              component={Inputs.Input}
              path="popisEn"
              label={messages.descriptionEn()}
              placeholder={messages.descriptionEnPlaceholder()}
              maxLength={200}
              required
              validators={requiredValidator}
            />
          </Row>
        </div>
      </div>
      <Row styled>
        <Field
          component={Inputs.TextArea}
          path="obsahCs"
          label={messages.contentCs()}
          placeholder={messages.contentCsPlaceholder()}
          required
          validators={requiredValidator}
        />
      </Row>
      <Row styled>
        <Field
          component={Inputs.TextArea}
          path="obsahEn"
          label={messages.contentEn()}
          placeholder={messages.contentEnPlaceholder()}
          required
          validators={requiredValidator}
        />
      </Row>
      <Row styled>
        <FieldStatic label={messages.attachments()}>
          <FileChooser path="prilohy" hasDelete />
        </FieldStatic>
      </Row>
      <Row styled>
        <></>
        <ButtonsSet>
          {onDelete && (
            <ActionButton onClick={onDelete} button={Buttons.Danger} inverse>
              {messages.delete()}
            </ActionButton>
          )}
          <ActionButton button={Buttons.Primary} validate submit inverse>
            {messages.submit()}
          </ActionButton>
          <ActionButton onClick={onCancel} button={Buttons.Default}>
            {messages.cancel()}
          </ActionButton>
        </ButtonsSet>
      </Row>
    </Form>
  );
}

ProvozniInformaceForm.propTypes = {
  onDelete: T.func,
  onCancel: T.func
};

export default React.memo(ProvozniInformaceForm);
